module.exports = __webpack_public_path__ + "img/austria-cardiovascular-diseases-female.d23b1f95.png";